import React from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { useMount } from "@sportal/cdk/hooks";

import { Mobile, NotMobile } from "../../../hocs/Responsive";
import { useIntlTranslate } from "../../../hooks";
import { Table } from "../../../components/table/Table";
import {
  RoamingRowSubComponent,
  RoamingRowSubComponentMobile,
} from "../roamingTables/RoamingRowSubComponent";
import { useRoamingDevices } from "../roamingTables/useRoamingDevices";
import {
  ROAMING_COLUMNS,
  ROAMING_COLUMNS_MOBILE,
  SEARCH_KEYS,
  INITIAL_SORT,
} from "./SingleRoamingDevicesTable.consts";
import { SingleRoamingDevicesTableHeader } from "./components";
import { fetchLogicalDevices } from "../../../store/devices/logicalDevices";

import "./SingleRoamingDevicesTable.scss";

export const SingleRoamingDevicesTable = () => {
  const dispatch = useDispatch();
  useMount(() => {
    dispatch(fetchLogicalDevices());
  });
  const roamingDevices = useRoamingDevices();
  const translate = useIntlTranslate();

  const subHeader = _.isEmpty(roamingDevices) && (
    <FormattedMessage id="roaming_devices_table_description" />
  );
  const caption = translate(
    `${
      _.isEmpty(roamingDevices)
        ? "roaming_devices_table_description"
        : "roaming"
    }`
  );

  return (
    <section className="roaming-table">
      <Mobile>
        <Table
          header={<SingleRoamingDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          visibleHeader={false}
          data={roamingDevices}
          hiddenColumns={["protectionStatus", "lastSeen"]}
          columns={ROAMING_COLUMNS_MOBILE}
          renderRowSubComponent={RoamingRowSubComponentMobile}
          defaultSorted={INITIAL_SORT}
          noDataMessageID={"no_devices_found"}
          subHeader={subHeader}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Mobile>
      <NotMobile>
        <Table
          header={<SingleRoamingDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          data={roamingDevices}
          columns={ROAMING_COLUMNS}
          renderRowSubComponent={RoamingRowSubComponent}
          defaultSorted={INITIAL_SORT}
          noDataMessageID={"no_devices_found"}
          subHeader={subHeader}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </NotMobile>
    </section>
  );
};
